module.exports = __webpack_public_path__ + "static/media/poisoned_shot.adfd2cc6.png";